// extracted by mini-css-extract-plugin
export const container = "Container-module--container--RJeP4";